module.exports = __webpack_public_path__ + "fonts/opensans-regular.3e7d6be4.woff";